import { render } from "./BankList.vue?vue&type=template&id=2a9dfe61"
import script from "./BankList.vue?vue&type=script&lang=js"
export * from "./BankList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__